import { createMuiTheme } from '@material-ui/core/styles';

const theme = {
    overrides: {
        MuiButton: {
            contained: {
                display: 'inline-block',
            },
        },
    },
    palette: {
        primary: {
            light: '#6CCB9B',
            main: '#0AB470',
            dark: '#009258',
            contrastText: '#fff',
        },
        secondary: {
            light: '#EBF6F1',
            main: '#FFFFFF',
            dark: '#4DB028',
            contrastText: '#000',
        },
        error: {
            light: '#FFE8E6',
            main: '#FF6259',
            dark: '#BC453E',
            contrastText: '#fff',
        },
    },
    typography: {
        fontFamily: '"adelle-sans", sans-serif',
        headline: {
            fontSize: '2.1025rem',
            fontWeight: 500,
            lineHeight: '2rem',
        },
        subheading: {
            fontSize: '1.3025rem',
            fontWeight: 150,
        },
        title: {
            fontSize: '1.46429em',
            fontWeight: 700,
        },
        caption: {
            fontSize: '1.20429em',
            color: '#4A4A4A',
            fontWeight: 600,
        },
        body1: {
            fontSize: '0.8725rem',
        },
        body2: {
            fontSize: '0.86125rem',
        },
        body3: {
            fontSize: '0.96125rem',
        },
        display3: {
            fontSize: '0.73625rem',
            letterSpacing: 0,
            lineHeight: '1.46429em',
            marginLeft: 0,
        },
        display4: {
            fontSize: '2.73625rem',
        },
        button: {
            fontSize: '1rem',
            fontWeight: 500,
            textTransform: 'none',
        },
    },
};

export default createMuiTheme(theme);
